module.exports = require("./ar-EG");